import React from 'react';
import {Button, ModalCard} from "@vkontakte/vkui";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS,
    MODAL_SUBHEADER_CLASS
} from "../modalStyles";

export const TournamentGoodLuckModal = ({nav}) => {
    const routeNavigator = useRouteNavigator();

    return (
        <ModalCard
            nav={nav}
            onClose={() => routeNavigator.hideModal()}
            className={MODAL_CARD_CLASS}
            header={<span className={MODAL_HEADER_CLASS}>Удачи в турнире!</span>}
            subheader={<span className={MODAL_SUBHEADER_CLASS}>Вы уже подписаны на уведомления. Мы будем держать вас в курсе.</span>}
            actions={
                <div className={"flex flex-col w-full"}>
                    <Button
                        size="l"
                        mode="secondary"
                        className={MODAL_SECONDARY_BUTTON_CLASS}
                        onClick={() => routeNavigator.hideModal()}
                    >
                        Закрыть
                    </Button>
                </div>
            }
        />
    );
};
